import { db } from "@/api/firebase";
import {
  ManhuntMapPoi,
  PoiWitnessContent,
} from "@/models/MapPois/ManHunt/ManhuntMapPoi";
import { MapPoiWarning } from "@/models/MapPois/Base/MapPoiWarning";
import { forIn, isEmpty } from "lodash";

export default class Warnings {
  mapPoi: ManhuntMapPoi;
  gameUid: string;
  poiWitnessContent: PoiWitnessContent[] = [];
  warningObject = {} as MapPoiWarning;

  constructor(mapPoi: ManhuntMapPoi, gameUid: string) {
    this.mapPoi = mapPoi;
    this.gameUid = gameUid;
  }

  checkMapPoiWarningErrors(): MapPoiWarning {
    if (this.mapPoi.title.en !== "START_ZONE") {
      this.poiWitnessContent = this.getWitnessContent();
      this.checkChallengeQuestion();
      this.checkChallengeFx();
      //this.checkDefaultFX();
      this.checkRunawayMods();
      this.checkWitnessHint();
      this.checkWitnessInf();
      this.checkWitnessQuestion();
      this.checkInactiveWithTargets();
      this.checkIfTargetExists();
      if (!isEmpty(this.warningObject)) {
        db.ref(
          "map_poi/" + this.gameUid + "/" + this.mapPoi.key + "/issues/warn/"
        ).set(this.warningObject);
      } else {
        db.ref(
          "map_poi/" + this.gameUid + "/" + this.mapPoi.key + "/issues/warn/"
        ).remove();
      }
    }

    return this.warningObject;
  }

  private checkChallengeQuestion(): void {
    if (
      this.mapPoi.challenge.active &&
      (this.mapPoi.challenge.puzzle.q === undefined ||
        this.mapPoi.challenge.puzzle.q?.txt.en.length == 0)
    ) {
      this.warningObject.chall_q_mia = {
        active: true,
        txt: { en: "Challenge: No Question Set" },
      };
    }
  }
  private checkChallengeFx(): void {
    if (
      this.mapPoi.challenge.active &&
      !this.mapPoi.challenge.on_fail.active &&
      !this.mapPoi.challenge.on_success.active &&
      !this.mapPoi.challenge.on_incorrect.active
    ) {
      this.warningObject.chall_on_fx = {
        active: true,
        txt: { en: "Challenge: No FX Set" },
      };
    }
  }
  private checkWitnessQuestion(): void {
    let warningText = "";
    let count = 0;
    if (this.mapPoi.witness.active) {
      this.poiWitnessContent.forEach((x: PoiWitnessContent) => {
        if (
          x.wit_q === undefined ||
          x.wit_q["q1"] === undefined ||
          x.wit_q["q1"].q.en.length == 0
        ) {
          warningText = warningText + "alt_" + count + ", ";
        }
        count++;
      });
    }
    if (warningText.length > 0) {
      this.warningObject.wit_no_q = {
        active: true,
        txt: {
          en:
            "Witness: No Witness Questions Set for " +
            warningText.substring(0, warningText.length - 2),
        },
      };
    }
  }
  private checkWitnessHint(): void {
    let warningText = "";
    let count = 0;
    if (this.mapPoi.witness.active) {
      this.poiWitnessContent.forEach((x: PoiWitnessContent) => {
        if (x.hint === undefined || x.hint.txt.en.length == 0) {
          warningText = warningText + "alt_" + count + ", ";
        }
        count++;
      });
      if (warningText.length > 0) {
        this.warningObject.wit_no_hint = {
          active: true,
          txt: {
            en:
              "Witness: No Hint set for " +
              warningText.substring(0, warningText.length - 2),
          },
        };
      }
    }
  }
  private checkWitnessInf(): void {
    let warningText = "";
    let count = 0;
    if (this.mapPoi.witness.active) {
      this.poiWitnessContent.forEach((x: PoiWitnessContent) => {
        if (x.inf === undefined || x.inf.txt.en.length == 0) {
          warningText = warningText + "alt_" + count + ", ";
        }
        count++;
      });
      if (warningText.length > 0) {
        this.warningObject.wit_no_inf = {
          active: true,
          txt: {
            en:
              "Witness: No Informant set for " +
              warningText.substring(0, warningText.length - 2),
          },
        };
      }
    }
  }
  private checkRunawayMods(): void {
    if (
      this.mapPoi.map_mods.active &&
      this.mapPoi.map_mods.type === "runaway" &&
      !this.mapPoi.map_mods.runaway?.on_fail.active &&
      !this.mapPoi.map_mods.runaway?.on_success.active
    ) {
      this.warningObject.mapmod_run_no_fx = {
        active: true,
        txt: { en: "Mapmods Runaways: No FX set" },
      };
    }
  }
  // private checkDefaultFX(): void {
  //   if (this.mapPoi.default_fx === undefined) {
  //     this.warningObject.no_def_fx = {
  //       active: true,
  //       txt: { en: "Default FX: No FX set" },
  //     };
  //   }
  // }

  private checkInactiveWithTargets(): void {
    if (
      !this.mapPoi.map_mods.active &&
      (this.mapPoi.map_mods.runaway?.targets !== undefined ||
        this.mapPoi.map_mods.trigger_list !== undefined)
    ) {
      this.warningObject.map_mods_inactive_with_target = {
        active: true,
        txt: {
          en:
            "Mapmods Runaway/Trigger: Targets are set but mapmods.active = false",
        },
      };
    }
  }

  private checkIfTargetExists(): void {
    if (this.mapPoi.map_mods.targetedBy !== undefined) {
      this.warningObject.map_mods_target_exists = {
        active: true,
        txt: {
          en:
            "Mapmods: This POI is the target of another POI (See mapmods 'Targeted By').",
        },
      };
    }
  }

  get getWarningArray(): string[] {
    const arr: string[] = [];
    forIn(this.mapPoi.issues?.warn, (val: any) => {
      arr.push(val.txt.en);
    });
    return arr;
  }

  private getWitnessContent(): PoiWitnessContent[] {
    const arr: PoiWitnessContent[] = [];
    forIn(this.mapPoi.witness.content, (val: PoiWitnessContent) => {
      arr.push(val);
    });
    return arr;
  }
}
